import { Component, Input} from '@angular/core';
import { IManagableObject } from '../../../admin-panel/IManagableObject';

@Component({
    selector: 'switch-all-checkbox',
    templateUrl: './switch-all-checkbox.component.html',
    styleUrls: ['./switch-all-checkbox.component.css'],
    standalone: false
})
export class SwitchAllCheckBoxComponent
{
  @Input()
  public items: IManagableObject[] = [];

  public onToggleAll(value: Event) {
    this.items.forEach((item) => {
      if (item.CanSelect === false) return;
      item.IsChecked = (event.target as HTMLInputElement).checked;
    });
  }
}
